[
  "Angleterre",
  "Écosse",
  "Irlande du Nord",
  "Pays de Galles",
  "Québec"
]
